import { FileUpload } from "primereact/fileupload";
import React, { useContext, useRef, useState } from "react";
import DropDown from "./DropDown";
import { AppDB } from "../App";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatDate } from "../config/Config";
import { PrintOut } from "../pages/reports/PrintOut";
import { helper } from "./utils/helper";
import { Image } from "primereact/image";
import { PrimeIcons } from "primereact/api";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { Button } from "primereact/button";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";

const AddSignature = ({ eventdocumentTypes = null, uploaded, setUploaded, setsignatureData, signatureData = [], selectedEvent = null }) => {
	const { lookUp } = useContext(AppDB);
	const fileRef = useRef(null);

	const [selectedDocument, setselectedDocument] = useState(null);

	const fileToBase64 = (file) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onloadend = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
			reader.readAsDataURL(file);
		});

	const handleUpload = async ({ files }) => {
		if (!selectedDocument && eventdocumentTypes) return;

		const uploads = await Promise.all(
			files.map(async (file) => {
				const fileExtension = file.name.split(".").pop() || "";
				const base64Data = await fileToBase64(file);

				if (!eventdocumentTypes) {
					// Use file name (without extension) as title
					const fileNameWithoutExt = file.name.replace(/\.[^/.]+$/, "");
					return {
						FileExt: fileExtension,
						BinaryData: base64Data,
						ContentType: file.type,
						title: fileNameWithoutExt,
						originalName: file.name
					};
				} else {
					// Standard logic with selected document type
					const base64String = base64Data.split(",")[1];
					return {
						FileExt: fileExtension,
						BinaryData: base64String,
						ContentType: file.type,
						documentTypeID: selectedDocument?.documentTypeID ?? 13,
						title: file.name.replace(/\.[^/.]+$/, ""),
						originalName: file.name
					};
				}
			})
		);

		// Update state
		if (uploads.length > 0) {
			if (selectedDocument) {
				// Store as array (multi-doc upload mode)
				setsignatureData([...(signatureData || []), ...uploads]);
			} else {
				// Store as single object (single-doc upload mode)
				setsignatureData(uploads[0]);
			}
			setUploaded(true);
			fileRef.current?.clear();
		}
	};
	var [showPdf, setShowPdf] = useState(false);
	var [pdf, setPdf] = useState(null);

	const b64toBlob = (b64Data, contentType = "application/pdf") => {
		const byteChars = atob(b64Data);
		const byteNumbers = new Array(byteChars.length).fill().map((_, i) => byteChars.charCodeAt(i));
		const byteArray = new Uint8Array(byteNumbers);
		return new Blob([byteArray], { type: contentType });
	};
	return (
		<div className="my-2 p-4">
			<ConfirmDialog />
			<PrintOut isReport={false} base64={pdf} setBase64={setPdf} showDialog={showPdf} setShowDialog={setShowPdf} />
			{eventdocumentTypes && (
				<DropDown
					value={selectedDocument?.name || "Select Document"}
					options={eventdocumentTypes}
					optionLabel="name"
					placeholder="Select a document type"
					onChange={(e) => setselectedDocument(e.value)}
				/>
			)}

			{!selectedDocument && eventdocumentTypes && <p className="text-red-500 mt-2">Please select a document type before uploading.</p>}

			{(selectedDocument && eventdocumentTypes) || eventdocumentTypes === null ? (
				<>
					<FileUpload
						ref={fileRef}
						name="fileUpload"
						multiple
						customUpload
						uploadHandler={handleUpload}
						auto
						mode="advanced"
						maxFileSize={1000000}
						accept="*/*"
						chooseLabel="Load Signature Image"
						uploadLabel="Upload"
						cancelLabel="Cancel"
						className="mt-4"
					/>
				</>
			) : null}
			{uploaded && signatureData && (
				<div className="mt-4 card">
					<h4 className="mb-3">Uploaded Documents</h4>
					<div className="card">
						{Array.isArray(signatureData) ? (
							<DataTable value={signatureData} stripedRows responsiveLayout="scroll">
								<Column field="title" header="Document Name" style={{ width: "250px" }} />
								<Column
									header="Preview"
									style={{ width: "250px" }}
									body={(rowData) => {
										const contentType = rowData?.ContentType;
										const base64 = rowData?.BinaryData;

										if (!base64 || !contentType) {
											return <span className="text-gray-500">No preview</span>;
										}

										if (contentType.includes("pdf")) {
											return (
												<span>
													<i
														onClick={() => {
															// turn the base64 string into a Blob
															const blob = b64toBlob(base64, "application/pdf");
															const url = URL.createObjectURL(blob);
															window.open(url, "_blank"); // opens the PDF in a new tab
														}}
														className="pi pi-file-pdf"
														style={{ fontSize: "1.5rem", color: "#ef4444", cursor: "pointer" }}
													/>
												</span>
											);
										} else if (contentType.includes("image")) {
											return (
												<Image
													src={`data:${contentType};base64,${base64}`}
													alt="Preview"
													imageStyle={{ width: "60px", height: "60px", objectFit: "contain", borderRadius: "4px" }}
													preview
												/>
											);
										}

										return <span className="text-gray-500">Unsupported type</span>;
									}}
								/>

								<Column field="ContentType" header="Content Type" style={{ width: "250px" }} />
								<Column
									header="Action"
									body={(rowData, { rowIndex }) => (
										<Button
											icon="pi pi-trash"
											className="p-button-danger p-button-rounded"
											style={{ width: "30px", height: "30px", textAlign: "center" }}
											onClick={(e) => {
												confirmDialog({
													target: e.currentTarget,
													message: "Are you sure you want to remove this document?",
													icon: "pi pi-exclamation-triangle",
													defaultFocus: "accept",
													accept: () => {
														if (Array.isArray(signatureData)) {
															const updated = signatureData.filter((_, i) => i !== rowIndex);
															setsignatureData(updated);
															if (updated.length === 0) {
																setUploaded(false);
															}
														} else {
															setsignatureData([]);
															setUploaded(false);
														}
													}
												});
											}}
										/>
									)}
								/>
							</DataTable>
						) : (
							<div className="border p-4 rounded shadow">
								<h5 className="font-semibold mb-2">{signatureData?.title}</h5>
								<p className="mb-2 text-sm text-gray-600">{signatureData?.originalName}</p>
								{/* <div className="mb-3">
					{signatureData.ContentType?.includes("image") ? (
						<img
							src={signatureData?.BinaryData}
							alt="Preview"
							style={{ width: "100px", height: "100px", objectFit: "contain", borderRadius: "6px" }}
						/>
					) : signatureData?.ContentType?.includes("pdf") ? (
						<iframe
							src={signatureData?.BinaryData}
							title="PDF Preview"
							style={{ width: "100px", height: "100px", border: "1px solid #ccc", borderRadius: "6px" }}
						/>
					) : (
						<span className="text-gray-500">No preview</span>
					)}
				</div> */}
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	);
};

export default AddSignature;
